import { useState } from "react";
import { nzTime } from "@/lib/hsUtil";

export const TYPES = ["Worker", "Subcontractor", "Visitor", "Delivery"];

export const Shell = ({ project, children }) => (
  <div className="min-h-screen bg-black text-white px-4 py-6" data-testid="site-signin-page">
    <div className="max-w-md mx-auto space-y-4">
      <div className="font-bold tracking-widest text-silver border border-silver px-3 py-1 inline-block text-sm">LW&amp;Co Building</div>
      {project && (
        <div>
          <h1 className="text-2xl font-semibold" data-testid="site-project-name">{project.name}</h1>
          {project.address && <div className="text-sm opacity-70" data-testid="site-project-address">{project.address}</div>}
        </div>
      )}
      {children}
      <div className="text-xs opacity-50 pt-4">LW&amp;Co Building Company Limited · Emergency: 111</div>
    </div>
  </div>
);

export const TypePicker = ({ value, onChange }) => (
  <div className="grid grid-cols-2 gap-2" data-testid="site-type-picker">
    {TYPES.map(t => (
      <button key={t} type="button" onClick={() => onChange(t)} data-testid={`site-type-${t.toLowerCase()}`}
        className={`py-3 rounded border text-sm transition-colors ${value === t ? "bg-silver text-black border-silver font-semibold" : "border-neutral-700 hover:border-silver"}`}>
        {t}
      </button>
    ))}
  </div>
);

export const DetailsForm = ({ form, setForm, onContinue, busy }) => {
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));
  return (
    <div className="card space-y-3" data-testid="site-details-form">
      <div className="text-silver">I am a…</div>
      <TypePicker value={form.type} onChange={t => setForm(f => ({ ...f, type: t }))} />
      <input className="input w-full" placeholder="Full name" autoComplete="name" value={form.name} onChange={set("name")} data-testid="site-name"/>
      <input className="input w-full" placeholder="Company" autoComplete="organization" value={form.company} onChange={set("company")} data-testid="site-company"/>
      <input className="input w-full" placeholder="Mobile phone" type="tel" autoComplete="tel" value={form.phone} onChange={set("phone")} data-testid="site-phone"/>
      <button className="btn-silver w-full py-3" disabled={busy} onClick={onContinue} data-testid="site-details-continue">Continue</button>
    </div>
  );
};

export const SignedInCard = ({ status, onSignOut, busy }) => {
  const [confirm, setConfirm] = useState(false);
  return (
    <div className="card space-y-3" data-testid="site-signed-in-card">
      <div className="text-lg">You're signed in on this site</div>
      <div className="text-sm opacity-70" data-testid="site-signed-in-since">Since {nzTime(status.signed_in_at)}</div>
      {!confirm ? (
        <button className="btn-silver w-full py-3" onClick={() => setConfirm(true)} data-testid="site-sign-out-btn">Sign out</button>
      ) : (
        <div className="border border-silver rounded p-3 space-y-3" data-testid="site-sign-out-confirm">
          <div>Sign out of this site now?</div>
          <div className="flex gap-2">
            <button className="btn-silver flex-1 py-3" disabled={busy} onClick={onSignOut} data-testid="site-sign-out-confirm-btn">Yes, sign me out</button>
            <button className="btn-ghost flex-1 py-3" onClick={() => setConfirm(false)} data-testid="site-sign-out-cancel-btn">Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
};
